module.exports = __webpack_public_path__ + "img/personal23.d5e90d24.jpeg";